module.exports = __webpack_public_path__ + "f2f26d68ea3305b5c1696536ab3514b3.png";